type Member = {
  name: string;
  inst: string;
  img: string;
  text: string;
};

export const member: Member[] = [
  {
    name: "吉田雪乃",
    inst: "Vo. & Gt.",
    img: "/images/240921/Yukino.jpg",
    text: "2023年に学生時代から離れていた音楽に取り組むことを決意。7月、ワンマンライブを成功させ、わずか1か月で5曲のオリジナル曲を生み出す。",
  },

  {
    name: "松下福寿",
    inst: "Key.",
    img: "/images/240921/Matsushita.jpg",
    text: "神奈川県横浜市出身。メーザーハウス、ピアノ科卒。卒業後本格的にプロ活動をスタート。ジャンルを問わず今井翼、IMALU、森山直太郎、大原櫻子など様々なアーティストと共演。また制作方面でも花澤香菜、雨宮天、すとぷり、サンリオなどの作品に録音やアレンジで参加。楽曲提供、編曲、アレンジメント等でも評価を得ている。現在はライブ、セッション、レコーディングや楽曲制作等、多岐にわたり精力的に活動している。",
  },
  {
    name: "松ヶ谷一樹",
    inst: "Bass.",
    img: "/images/240921/Matsugaya.jpg",
    text: "1997年生まれ。千葉県出身。祖父の影響でベースを始める。音楽専門学校に入学、在学中よりプロ活動を開始する。特待生で卒業後、メジャーアーティストのレコーディング、ライブ、CM出演等、数多く携わる。",
  },
  {
    name: "杉崎尚道",
    inst: "Dr.",
    img: "/images/240921/Sugisaki.jpg",
    text: "高校時代より独学でドラムを始め、大学ではビッグバンドジャズに傾倒。卒業後は渡辺豊氏、中川広氏、大槻kalta英宣氏らに師事。宮下遊、seeeeecun、Yuuki Miyake（Mi8k）、宮澤佐江、河西智美（元AKB48）のライブサポート。ミュージカル「風雲新撰組」「信長の野望」の劇伴など様々なプロジェクト、ジャンルで活動中。",
  },
];
